export const awsUrl = (
  containerFile: string,
  idxFirst: number,
  mobile: boolean,
  idxSecond?: number,
) => {
  return `https://storage.googleapis.com/seniorcare_kiosk/connectedcar/home/${mobile ? 'mobile_' : ''}${containerFile}_${idxFirst}${idxSecond !== undefined ? `_${idxSecond}` : ''}.png`
}

export const awsImgSrc = (
  folder: string,
  isMobile: boolean,
  imgName: string,
) => {
  return `https://storage.googleapis.com/seniorcare_kiosk/intro/${folder}/${isMobile ? 'mobile' : 'web'}_${imgName}.png`
}
